import React from 'react';
import Icon from '@pushpay/icon';

const ErrorIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.432 4.15c5.624-1.075 10.493 3.794 9.417 9.417-.6 3.145-3.137 5.681-6.282 6.283-5.623 1.075-10.492-3.793-9.416-9.418.6-3.144 3.136-5.68 6.28-6.281m-.125 17.71A10.014 10.014 0 0021.86 10.305c-.68-4.143-4.023-7.484-8.166-8.166A10.013 10.013 0 002.14 13.694c.682 4.143 4.022 7.485 8.166 8.166M12 13.635h-.01a.99.99 0 01-.99-.988V7.649a.99.99 0 01.99-.99H12a1 1 0 011 1v4.977a1 1 0 01-1 1m0 3.464A1.1 1.1 0 1112 14.9 1.1 1.1 0 0112 17.1",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default ErrorIcon;